import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';
import type { CategoryTab } from '../avatarDecorate.logic';
const TAB_LABEL_KEY = {
  face: 'avatarDecorate.tab.face',
  skin: 'avatarDecorate.tab.skin',
  hair: 'avatarDecorate.tab.hair',
  clothes: 'avatarDecorate.tab.clothes',
  glasses: 'avatarDecorate.tab.glasses'
} as const satisfies Record<CategoryTab, string>;
const TAB_ORDER: CategoryTab[] = ['face', 'skin', 'hair', 'clothes', 'glasses'];
export const AvatarCategoryTabs = ({
  activeTab,
  onSelect
}: {
  activeTab: CategoryTab;
  onSelect: (tab: CategoryTab) => void;
}) => {
  const {
    t
  } = useTranslation('common');
  return <div className="flex flex-row gap-none overflow-x-auto mobile-lg:flex-col mobile-lg:gap-3xs mobile-lg:overflow-visible" data-sentry-component="AvatarCategoryTabs" data-sentry-source-file="AvatarCategoryTabs.tsx">
      {TAB_ORDER.map(tab => {
      const isActive = tab === activeTab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} className={cn('relative flex h-[41px] flex-1 basis-[72px] items-center justify-center whitespace-nowrap px-[10px] text-body-md-medium text-gray-600 transition-colors', 'mobile-lg:h-[32px] mobile-lg:flex-none mobile-lg:basis-auto mobile-lg:justify-start mobile-lg:px-[30px]', isActive ? 'font-bold text-strong' : 'hover:text-strong')}>
            {t(TAB_LABEL_KEY[tab])}
            {isActive && <span className="absolute bottom-0 left-0 h-[2px] w-full bg-strong-default mobile-lg:bottom-1/2 mobile-lg:left-0 mobile-lg:h-[22px] mobile-lg:w-[4px] mobile-lg:translate-y-1/2 mobile-lg:rounded-r-[2px]" />}
          </button>;
    })}
    </div>;
};